<template>
  <main-layout
    customControls
    controlsBg="light"
    :hasControlsBar="false"
    :breadcrumb="getBreadcrumb">

    <div class="container">

      <alert
        v-if="alertVisible"
        :message="alertMessage"
        :type="alertType">
      </alert>

      <div class="center-horizontal">
        <search-input
          ref="foodSearch"
          class="search-input"
          :focus="true"
          v-on:input="onChangeFilter"/>

        <btn-pill
          @click="newFood"
          btn-text="Nuevo Alimento"
          btn-size="s"
          class="margin-left-xl"/>
      </div>

      <grid-row class="margin-top-l margin-bottom-xl" column-align="left">
        <grid-col col-size="2">
          <food-table :data="filteredData"
                      v-on:rowClick="selectedRow"/>
        </grid-col>

        <div class="container" style="padding-top: 0">
          <h3 class="flex" v-if="esName === ''"> {{ 'Selecciona un Alimento' }} </h3>
          <h3 class="flex" v-else> {{ this.esName + ' / ' + this.enName }} </h3>
          <div class="two-column-div">
            <label-input
              type="Number"
              ref="id"
              form-size="m"
              :label="'Id de Alimento: '"
              :value=this.foodId
              :margin="false"
              :disabled="true">
            </label-input>

            <label-input
              ref="esName"
              form-size="m"
              :label="'Nombre: '"
              :value=this.esName
              :margin="false"
              v-on:input="(value) => {this.esName = value}"
              v-on:click="onInputResetBorder"
              required>
            </label-input>

            <label-input
              ref="enName"
              form-size="m"
              :label="'Name: '"
              :value=this.enName
              :margin="false"
              v-on:input="(value) => {this.enName = value}"
              v-on:click="onInputResetBorder"
              required>
            </label-input>

            <label-input
              ref="marca"
              form-size="m"
              :label="'Marca: '"
              :value=this.marca
              v-on:input="(value) => {this.marca = value}"
              :margin="false">
            </label-input>

            <label-input
              type="Number"
              ref="group"
              form-size="m"
              :label="'Grupo: '"
              :value=this.group
              :margin="false"
              v-on:input="(value) => {this.group = value}"
              v-on:click="onInputResetBorder"
              required>
            </label-input>

            <label-input
              type="Number"
              ref="Portion"
              form-size="m"
              :label="'Porción (g): '"
              :value=this.portion
              :margin="false"
              v-on:input="(value) => {this.portion = value}"
              v-on:click="onInputResetBorder"
              required>
            </label-input>

            <label-input
              type="Number"
              ref="kcal"
              form-size="m"
              :label="'Energía (kcal) en 100g: '"
              :value=this.kCals
              :margin="false"
              v-on:input="(value) => {
                this.kCals = value;
                updatekJoules();
              }"
              v-on:click="onInputResetBorder"
              required>
            </label-input>

            <label-input
              type="Number"
              ref="kjoule"
              form-size="m"
              :label="'Energia (kJ) en 100g: '"
              :value=this.kJoule
              :margin="false"
              v-on:input="(value) => {
                this.kJoule = value;
                updatekCals();
              }"
              v-on:click="onInputResetBorder"
              required>
            </label-input>

            <label-input
              type="Number"
              ref="fat"
              form-size="m"
              :label="'Grasas (g) en 100g: '"
              :value=this.fats
              :margin="false"
              v-on:input="(value) => {
                this.fats = value;
                updateInsaturated();
              }"
              v-on:click="onInputResetBorder"
              required
              under100>
            </label-input>

            <label-input
              type="Number"
              ref="saturated"
              form-size="m"
              :disabled="false"
              :label="'Grasas saturadas (g) en 100g: '"
              :value="this.saturated"
              v-on:input="(value) => {
                this.saturated = value
                updateInsaturated()
              }"
              :margin="false">
            </label-input>

            <label-input
              type="Number"
              ref="unsaturated"
              form-size="m"
              :disabled="true"
              :label="'Grasas insaturadas (g) en 100g: '"
              :value="this.insaturated"
              v-on:input="(value) => {this.insaturated = value}"
              :margin="false">
            </label-input>

            <label-input
              type="Number"
              ref="mono"
              form-size="m"
              :label="'Acido Graso Monoinsaturado (g) en 100g: '"
              :value=this.mono
              v-on:input="(value) => {this.mono = value}"
              :margin="false">
            </label-input>

            <label-input
              type="Number"
              ref="poli"
              form-size="m"
              :label="'Acido Graso Polinsaturado (g) en 100g: '"
              :value=this.poli
              v-on:input="(value) => {this.poli = value}"
              :margin="false">
            </label-input>

            <label-input
              type="Number"
              ref="carbs"
              form-size="m"
              :label="'Carbs (g) en 100g: '"
              :value=this.carbs
              :margin="false"
              v-on:input="(value) => {this.carbs = value}"
              v-on:click="onInputResetBorder"
              required
              under100>
            </label-input>

            <label-input
              type="Number"
              ref="sugar"
              form-size="m"
              :label="'Azúcares: '"
              :value=this.sugar
              v-on:input="(value) => {this.sugar = value}"
              :margin="false"/>

            <label-input
              type="Number"
              ref="fiber"
              form-size="m"
              :label="'Fibra (g) en 100g: '"
              :value=this.fiber
              :margin="false"
              v-on:input="(value) => {this.fiber = value}"
              v-on:click="onInputResetBorder"
              required
              under100>
            </label-input>

            <label-input
              type="Number"
              ref="protein"
              form-size="m"
              :label="'Proteinas (g) en 100g: '"
              :value=this.proteins
              :margin="false"
              v-on:input="(value) => {this.proteins = value}"
              v-on:click="onInputResetBorder"
              required
              under100>
            </label-input>

            <label-input
              type="Number"
              ref="salt"
              form-size="m"
              :label="'Sal: '"
              :value=this.salt
              v-on:input="(value) => {this.salt = value}"
              :margin="false"/>
          </div>
          <div>
            <multi-select :options="options"
                          :selected-options="items"
                          placeholder="Añadir una propiedad"
                          @select="onSelect">
            </multi-select>
          </div>
          <btn-pill
            @click="saveChanges()"
            btn-text="Guardar Cambios"
            btn-size="s"
            class="margin-top-m"/>
          <btn-pill
            @click="onDelete"
            btn-text="Borrar Alimento"
            btn-size="s"
            class="margin-top-m"
            btn-type="secondary"/>
        </div>

      </grid-row>

    </div>
    <ok-cancel-modal
      v-if="showConfirmationDeleteModal"
      v-on:ok="onDeleteConfirm"
      v-on:cancel="onDeleteCancel"
      :title="deleteModalMessage"
      :message="deleteModalMessage"
      :okButton="$t('commons.delete')"
      :cancelButton="$t('commons.cancel')">
      <div slot="body">
        <ul>
          <li>
            {{ foodToDelete.data.foodEspName }}
          </li>
        </ul>
      </div>
    </ok-cancel-modal>
    <food-add-modal
      v-if="showFoodModal"
      :foods="getFilteredFoods"
      v-on:close="closeFoodModal"
    />
  </main-layout>
</template>

<script>
import MainLayout from '@/layouts/MainLayout';
import HealthChart from 'BRAND/components/explorer/HealthChart';
import api from 'BRAND/api/foodManager';
import HealthExplorerControls from 'BRAND/components/explorer/HealthExplorerControls';
import HealthExplorerControlsUserSelect from 'BRAND/components/explorer/HealthExplorerControlsUserSelect';
import TableComponent from '@/components/shared/table/components/TableComponent';
import TableColumn from '@/components/shared/table/components/TableColumn';
import FoodTable from '../components/workspace/FoodTable';
import GridRow from '@/components/shared/grid/GridRow';
import GridCol from '@/components/shared/grid/GridCol';
import faQuestionCircle from '@fortawesome/fontawesome-free-solid/faQuestionCircle';
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import LabelInput from '@/components/shared/forms/LabelInput';
import SearchInput from '@/components/shared/SearchInput';
import {MultiSelect} from 'vue-search-select';
import BtnPill from '../../../components/shared/buttons/BtnPill';
import FoodAddModal from '../components/workspace/FoodAddModal';
import OkCancelModal from '@/components/shared/dialogs/OkCancelModal';
import Alert from '@/components/shared/alert/Alert';

export default {
  name: 'FoodManager',
  components: {
    BtnPill,
    FoodTable,
    MainLayout,
    LabelInput,
    HealthExplorerControls,
    HealthChart,
    HealthExplorerControlsUserSelect,
    TableComponent,
    TableColumn,
    GridCol,
    GridRow,
    FontAwesomeIcon,
    SearchInput,
    MultiSelect,
    FoodAddModal,
    OkCancelModal,
    Alert
  },
  data () {
    return {
      /* Modals */
      alertVisible: false,
      alertMessage: '',
      chartData: null,
      filteredData: null,
      esName: '',
      enName: '',
      portion: null,
      group: null,
      proteins: null,
      fats: null,
      kJoule: null,
      kCals: null,
      carbs: null,
      fiber: null,
      salt: null,
      sugar: null,
      mono: null,
      poli: null,
      insaturated: null,
      saturated: null,
      foodId: null,
      marca: '',
      foodFilter: '',
      showFoodModal: false,
      showConfirmationDeleteModal: false,
      foodToDelete: null,
      rowSelected: null,
      options: [
        {value: '1', text: 'Agua', property: 'atriAgua'},
        {value: '2', text: 'Alcohol', property: 'atriAlcohol'},
        {value: '3', text: 'Deporte', property: 'atriDeporte'},
        {value: '4', text: 'Estimulante', property: 'atriEstimulante'},
        {value: '5', text: 'Pre-ejercicio', property: 'atriPreSport'},
        {value: '6', text: 'Durante-ejercicio', property: 'atriDuringSport'},
        {value: '7', text: 'Post-ejercicio', property: 'atriPostSport'},
        {value: '8', text: 'Fibra', property: 'atriFibra'},
        {value: '9', text: 'Azúcar añadido', property: 'atriSugarAdd'},
        {value: '10', text: 'Azúcar libre', property: 'atriSugarFree'},
        {value: '11', text: 'Natural', property: 'atriNatural'},
        {value: '12', text: 'Procesado', property: 'atriProcessed'},
        {value: '13', text: 'Ultraprocesado', property: 'atriUltraprocessed'},
        {value: '14', text: 'Sin gluten', property: 'atriGlutenFree'},
        {value: '15', text: 'Vegetariano', property: 'atriVegetarian'},
        {value: '16', text: 'Vegano', property: 'atriVegan'},
        {value: '17', text: 'Sin lactosa', property: 'atriLactoseFree'},
        {value: '18', text: 'Antiinflamatorio', property: 'atriAntiinflammatory'},
        {value: '19', text: 'Antiinflamatorio posible', property: 'atriPosibleAntiinflammatory'},
        {value: '20', text: 'Antioxidante', property: 'atriAntioxidant'},
        {value: '21', text: 'Antioxidante posible', property: 'atriPosibleAntioxidant'},
        {value: '22', text: 'IG alto', property: 'atriHighGlycemicIndex'},
        {value: '23', text: 'IG medio', property: 'atriMediumGlycemicIndex'},
        {value: '24', text: 'Alto en proteina', property: 'atriHighProtein'},
        {value: '25', text: 'Valor biológico proteina alto', property: 'atriHighProteinBiologicalValue'},
        {value: '26', text: 'Valor biológico proteina medio', property: 'atriMediumProteinBiologicalValue'},
        {value: '27', text: 'Alto en grasa saturadas', property: 'atriHighSaturatedFat'},
        {value: '28', text: 'Alto en grasa trans', property: 'atriHighTransFat'},
        {value: '29', text: 'Alto en HC refinados', property: 'atriHighRefinedCarbohydrates'},
        {value: '30', text: 'Integral', property: 'atriIntegral'},
        {value: '31', text: 'Integral medio', property: 'atriMediumIntegral'},
        {value: '32', text: 'FODMAP', property: 'atriFodmap'},
        {value: '33', text: 'Fe', property: 'atriFe'},
        {value: '34', text: 'OMEGA-3', property: 'atriOmega3'},
        {value: '35', text: 'Ácido fólico', property: 'atriFolidAcid'},
        {value: '36', text: 'Calcio', property: 'atriCalcium'},
        {value: '37', text: 'Vit D', property: 'atriVitaminD'},
        {value: '38', text: 'Embarazo', property: 'atriPregnancy'},
        {value: '39', text: 'Menopausia', property: 'atriMenopause'}
      ],
      searchText: '',
      items: [],
      lastSelectItem: {},
      icons: {
        question: faQuestionCircle
      }
    };
  },
  watch: {
    selectedFilter: {
      handler: function () {
        this.requestData();
      }
    }
  },
  mounted () {
    this.requestData();
  },
  computed: {
    getBreadcrumb () {
      return [
        {name: this.$t('menu.workspace'), link: '/workspace'},
        {name: this.$t('health.foodManager.title'), disabled: true}];
    },
    getFilterOptions () {
      let reObj = [{label: this.$t('health.explorer.controls'), id: 1},
        {label: this.$t('health.explorer.controlsDay'), id: 2},
        {label: this.$t('health.explorer.controls14'), id: 3},
        {label: this.$t('health.explorer.controls30'), id: 4}
      ];
      return reObj;
    },
    displayNameErrorMessage () {
      let errorMessage = this.$t('commons.mandatoryFieldMessage');
      return errorMessage;
    }
  },
  methods: {
    getFilteredFoods () {
      if (this.foodFilter !== '') {
        this.filteredData = this.chartData.filter(food => {
          return replaceSpecialChars(food.foodEspName.toUpperCase()).includes(replaceSpecialChars(this.foodFilter.toUpperCase()));
        });
      }

      return this.filteredData.sort(function (a, b) {
        return a.foodEspName.length - b.foodEspName.length;
      });
    },
    updateInsaturated () {
      this.insaturated = Math.round((this.fats - this.saturated) * 100) / 100;
    },
    updatekJoules () {
      const value = this.kCals * 4.184;
      this.kJoule = Math.round(value * 100) / 100;
    },
    updatekCals () {
      const value = this.kJoule / 4.184;
      this.kCals = Math.round(value * 100) / 100;
    },
    selectedRow (row) {
      this.rowSelected = row;
      this.items = [];
      this.esName = row.data.foodEspName;
      this.enName = row.data.foodEngName;
      this.portion = Math.round(row.data.portion * 100) / 100;
      this.group = row.data.foodGroupId;
      this.proteins = Math.round(row.data.proteinGramValue * 100) / 100;
      this.fats = Math.round(row.data.fatGramsValue * 100) / 100;
      this.kJoule = Math.round(row.data.energykJValue * 100) / 100;
      this.updatekCals();
      this.carbs = Math.round(row.data.carbohydrateGramValue * 100) / 100;
      this.fiber = Math.round(row.data.fibreGramValue * 100) / 100;
      this.salt = Math.round(row.data.salt * 100) / 100;
      this.sugar = Math.round(row.data.sugar * 100) / 100;
      this.mono = Math.round(row.data.monounsaturatedFattyAcid * 100) / 100;
      this.poli = Math.round(row.data.polyunsaturatedFattyAcid * 100) / 100;
      this.marca = row.data.marca;
      this.insaturated = Math.round(row.data.unsaturatedFattyAcid * 100) / 100;
      this.saturated = Math.round(row.data.saturatedFattyAcid * 100) / 100;
      this.foodId = row.data.foodId;
      this.options.forEach(option => {
        if (row.data[option.property]) {
          this.items.push(option);
        }
      });
    },
    onChangeFilter (filter) {
      this.foodFilter = filter;
      this.getFilteredFoods();
    },
    onDelete () {
      this.foodToDelete = this.rowSelected;
      this.deleteModalMessage = 'Borrar Alimento';
      this.showConfirmationDeleteModal = true;
    },
    onDeleteCancel () {
      this.foodToDelete = null;
      this.showConfirmationDeleteModal = false;
    },
    onDeleteConfirm () {
      const id = this.foodToDelete.data.foodId;
      let name = this.foodToDelete.data.foodEspName;
      api.deleteFood(this, id).then(() => {
        showAlert(this, this.$t('health.foodManager.successDelete', {name: name}), 'success');
        this.requestData();
      }, () => {
        showAlert(this, this.$t('health.foodManager.errorDelete', {name: name}), 'error');
      });
      this.foodToDelete = null;
      this.resetFields();
      this.showConfirmationDeleteModal = false;
    },
    saveChanges () {
      let requieredFieldError = false;
      document.querySelectorAll('[required]').forEach(function (i) {
        if (i.querySelector('input').value === '') {
          i.querySelector('input').style.border = '1px solid red';
          requieredFieldError = true;
        }
      });
      let fieldsOver100 = false;
      fieldsOver100 = this.underLimit(fieldsOver100);
      if (fieldsOver100) {
        this.alertVisible = true;
        this.alertMessage = 'Los valores exceden los 100g';
        this.alertType = 'error';
        setTimeout(() => {
          this.alertVisible = false;
        }, 2000);
      }
      if (requieredFieldError) {
        this.alertVisible = true;
        this.alertMessage = 'Por favor, rellene todos los campos requeridos';
        this.alertType = 'error';
        setTimeout(() => {
          this.alertVisible = false;
        }, 2000);
      }
      let attributes = {};
      for (let i = 0; i < this.items.length; i++) {
        let item = this.items[i];
        const property = item.property;
        attributes[property] = true;
      }
      if (!requieredFieldError && !fieldsOver100) {
        let food = {
          foodId: this.foodId,
          foodEspName: this.esName,
          foodEngName: this.enName,
          portion: this.portion,
          foodGroupId: this.group,
          proteinGramValue: this.proteins,
          fatGramsValue: this.fats,
          energykJValue: this.kJoule,
          carbohydrateGramValue: this.carbs,
          fibreGramValue: this.fiber,
          sugar: this.sugar,
          salt: this.salt,
          monounsaturatedFattyAcid: this.mono,
          polyunsaturatedFattyAcid: this.poli,
          unsaturatedFattyAcid: this.insaturated,
          saturatedFattyAcid: this.saturated,
          marca: this.marca,
          ...attributes
        };
        this.sendData(food);
      }
    },
    sendData (food) {
      api.updateFood(this, food).then(() => {
        this.alertVisible = true;
        this.alertMessage = 'Alimento añadido correctamente';
        this.alertType = 'success';
        setTimeout(() => {
          this.resetFields();
          this.requestData();
          this.alertVisible = false;
        }, 1000);
      }).catch((error) => {
        this.alertVisible = true;
        this.alertMessage = error.body.message;
        this.alertType = 'error';
        setTimeout(() => {
          this.alertVisible = false;
        }, 1000);
      });
    },
    onInputResetBorder (event) {
      event.target.style.border = '1px solid #d9d9d9';
    },
    requestData () {
      api.getFoodData(this).then(data => {
        this.chartData = data;
        this.filteredData = data;
      });
    },
    onSelect (items, lastSelectItem) {
      this.items = items;
      this.lastSelectItem = lastSelectItem;
    },
    // deselect option
    reset () {
      this.items = []; // reset
    },
    resetFields () {
      this.esName = '';
      this.enName = '';
      this.portion = null;
      this.group = null;
      this.proteins = null;
      this.fats = null;
      this.kJoule = null;
      this.carbs = null;
      this.fiber = null;
      this.salt = null;
      this.sugar = null;
      this.mono = null;
      this.poli = null;
      this.insaturated = null;
      this.saturated = null;
      this.foodId = null;
      this.items = [];
      this.marca = null;
    },
    newFood () {
      this.showFoodModal = true;
      this.resetFields();
    },
    closeFoodModal () {
      this.showFoodModal = false;
      this.requestData();
    },
    underLimit (error) {
      document.querySelectorAll('[under100]').forEach(function (i) {
        if (i.querySelector('input').value > 100) {
          i.querySelector('input').style.border = '1px solid red';
          error = true;
        }
      });
      return error;
    }
  },
  hiddeComp () {
    this.disableUserSelect = !this.disableUserSelect;
  },
  requestDataInEmit () {
    if (this.disableUserSelect) {
      this.requestData();
    }
  },

  timeFormatter (timestamp) {
    if (timestamp === null) return this.$t('health.summary.average');
    const date = new Date(timestamp * 1000);
    return date.toLocaleDateString('en-GB');
  }
};
const replaceSpecialChars = (str) => {
  return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '') // Remove accents
    .replace(/([^\w]+|\s+)/g, '-') // Replace space and other characters by hyphen
    .replace(/(^-+|-+$)/g, ''); // Remove extra hyphens from beginning or end of the string
};

const showAlert = (context, message, type) => {
  context.alertVisible = true;
  context.alertMessage = message;
  context.alertType = type;
  context.showAlert = true;
  setTimeout(() => {
    context.alertVisible = false;
  }, 2000);
};
</script>

<style lang="scss" scoped>
@import "src/stylesheets/variables";

.container {
  padding-top: $sp-margin;
  padding-bottom: $sp-margin;
  flex-grow: 1;
  min-height: 100%;
  @supports (-webkit-touch-callout: none) {
    display: -ms-flexbox;
  }
  @supports not (-webkit-touch-callout: none) {
    display: flex;
  }
  flex-direction: column;
}

.center-horizontal {
  display: flex;
  flex-direction: row;
}

.chart-title {
  display: flex;
  font-size: 1.2rem;
  margin-bottom: $sp-margin-small;
  text-align: center;
  align-items: center
}

.two-column-div {
  display: grid;
  grid-template-rows: repeat(6, auto);
  grid-gap: 10px;
  grid-auto-flow: column;
}

.update-button {
  font-size: 1rem;
  width: 100%;
}

.header {
  display: flex;
  justify-content: space-between;

  &__title {
    margin-bottom: $sp-margin;
    @media (min-width: $breakpoint) {
      display: flex;
      h1 {
        margin-bottom: 0;
        margin-right: $sp-margin;
        padding-right: $sp-margin;
      }
    }
  }
}

.flex-column {
  flex-direction: column;
}

.flex-direction-variable {
  flex-direction: column;
  @media (min-width: $screen-wide) {
    flex-direction: row;
  }
}

.max-width {
  width: 100%;
}

.form-group2 {
  display: block;

  label {
    display: block;
    color: $black-trans4;

    .form--inverse & {
      color: $white-trans4;
    }
  }

  input {
    background-color: $white;
    border: 1px solid $black-trans6;
    border-radius: $radius;
    padding-left: $sp-margin-small;
    padding-right: $sp-margin-small;
    height: $height3;
    //TODO: HOW TO OVERRIDE THIS SETTING?
    //min-width: $form-minw;
    width: 100%;
    caret-color: $active;

    &:disabled {
      background: $disabled;
    }

    &::placeholder {
      color: $black-trans6;
    }

    &:hover {
      border-color: $black-trans4;
    }

    &:focus,
    &:active {
      outline: 0;
      border-color: $active;
    }

    .form--inverse & {
      background-color: transparent;
      border-color: $white-trans6;
      color: $white;

      &::placeholder {
        color: $white-trans6;
      }

      &:hover {
        border-color: $white-trans4;
      }

      &:focus,
      &:active {
        border-color: $active;
      }
    }

    &[error="true"] {
      border-color: $error;
    }
  }

  .error-message {
    color: $error;
  }

  .hidden {
    visibility: hidden;
  }
}

.hide-on-desktop {
  @media only screen and (hover: hover) and (pointer: fine) {
    display: none;
  }
}

.hide-on-phone {
  @media only screen and (hover: none) and (pointer: coarse) {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/brand/health/layouts/FoodManager.vue